import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
} from '@angular/core';
import { CommonModule } from '@angular/common';

export type FgaView = 'users' | 'groups' | 'services';

export interface NavItem {
  id: FgaView;
  label: string;
  iconClass: string;
}

@Component({
  selector: 'fga-nav-bar',
  templateUrl: './fga-nav-bar.component.html',
  styleUrls: ['./fga-nav-bar.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonModule],
})
export class FgaNavBarComponent {
  @Input() activeView: FgaView = 'groups';
  @Input() isAuthzAdmin = false;

  @Output() viewChange = new EventEmitter<FgaView>();

  private readonly allItems: NavItem[] = [
    { id: 'groups', label: 'Groups', iconClass: 'ds-ngkit ds-ngkit-user-groups' },
    { id: 'users', label: 'Users', iconClass: 'ds-ngkit ds-ngkit-user' },
    { id: 'services', label: 'Services', iconClass: 'ds-ngkit ds-ngkit-server' },
  ];

  get items(): NavItem[] {
    return this.allItems.filter(item => item.id === 'groups' || this.isAuthzAdmin);
  }

  onSelect(item: NavItem): void {
    if (item.id !== this.activeView) {
      this.viewChange.emit(item.id);
    }
  }

  onKeydown(event: KeyboardEvent, index: number): void {
    let newIndex: number | null = null;

    switch (event.key) {
      case 'ArrowDown':
      case 'ArrowRight':
        event.preventDefault();
        newIndex = (index + 1) % this.items.length;
        break;
      case 'ArrowUp':
      case 'ArrowLeft':
        event.preventDefault();
        newIndex = (index - 1 + this.items.length) % this.items.length;
        break;
      case 'Home':
        event.preventDefault();
        newIndex = 0;
        break;
      case 'End':
        event.preventDefault();
        newIndex = this.items.length - 1;
        break;
    }

    if (newIndex !== null) {
      const buttons = (event.target as HTMLElement)
        .closest('[role="tablist"]')
        ?.querySelectorAll<HTMLButtonElement>('[role="tab"]');
      buttons?.[newIndex]?.focus();
    }
  }
}
